import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';

import { ProductListResponse } from './product-list.types';

// deprecated service ref.: getProductsService_DEPRECATED

// ✅ Implementado
export async function productListService() {
  const { response, data } = await BACKEND.get<ProductListResponse>(ENDPOINT.SILOBAG_PRODUCT);

  return {
    response,
    summary: data,
  };
}
